// Renders a team-member photo correctly. If the photo is the shared dual-avatar
// illustration (male + female side by side), we crop precisely to one figure
// using a background-image with 200% sizing — so it works at any aspect ratio.
// Real headshots fall back to a standard cover <img>.

import { TEAM_AVATAR } from "@/lib/data";

export default function TeamPhoto({ member, className = "", style = {} }) {
    const isShared = member?.photo === TEAM_AVATAR;
    const horizontal = member?.gender === "female" ? "0%" : "100%";

    if (isShared) {
        return (
            <div
                role="img"
                aria-label={`${member.name}, ${member.role}`}
                className={className}
                style={{
                    backgroundImage: `url("${TEAM_AVATAR}")`,
                    backgroundSize: "200% 100%",
                    backgroundPosition: `${horizontal} center`,
                    backgroundRepeat: "no-repeat",
                    backgroundColor: "#0F1B2E",
                    ...style,
                }}
            />
        );
    }

    return (
        <img
            src={member.photo}
            alt={`${member.name}, ${member.role}`}
            loading="lazy"
            className={className}
            style={{ objectFit: "cover", ...style }}
        />
    );
}
